import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BlockUiService {
  public isBlocked$ = new BehaviorSubject<boolean>(false);
  private requestCount = 0;
  private timer: number | null = null;
  private readonly DELAY_START_MS = 200;

  /**
   * Starts the block UI process with a delay.
   */
  start() {
    this.requestCount++;
    // Only start the timer for the very first request.
    if (this.requestCount === 1) {
      this.timer = window.setTimeout(() => {
        // When the timer completes, show the blocker.
        this.isBlocked$.next(true);
        this.timer = null;
      }, this.DELAY_START_MS);
    }
  }

  /**
   * Stops the block UI. Will cancel the timer if requests finish quickly.
   */
  stop() {
    if (this.requestCount > 0) {
      this.requestCount--;
    }
    // If all requests are complete.
    if (this.requestCount === 0) {
      // Check if the timer is still pending.
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
      // Always ensure the blocker is turned off if it was already visible.
      this.isBlocked$.next(false);
    }
  }
}
